import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';


export function InventoryModal({ setShowModal, getData }) {
  const {userProfile, logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const [formFields, setFormFields] = useState({});

  const handleSubmit = async () => {
    const formData = new FormData();
    Object.entries(formFields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    setLoading(true)
    try {
        const response = await axios.post(base_url + '/create-inventory-item.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                accountid: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.code == 403) {
            logOutFunction()
        }
        if (response.data.status) {
            setTostMessage({
                messageType: 'success',
                message: response.data.message
            })
            getData();
            setShowModal(false);
        } else {
        setTostMessage({
            messageType: 'error',
            message: response.data.message
        })
        }
        setLoading(false)
    } catch (error) {
        setLoading(false)
        setTostMessage({
            messageType: 'error',
            message: 'Network Error'
        })
    }
  };

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div className='w-[80%] flex justify-end text-underline text-[#ff0000]'>
                    <p className='cursor-pointer' onClick={() => setShowModal(false)}>Cancel</p>
                </div>
                <a className='text-dark text-[15px] font-bold'>Create Inventory Item</a>
                 <select
                    className="w-[80%] mx-auto border p-2 rounded my-2"
                    // value={formFields?.apt_id}
                    onChange={(e) => setFormFields({...formFields, unit_of_measurement: e.target.value})}
                  >
                    <option value="">Choose Unit of Measurement</option>
                    <option value={'unit(s)'}>{'Unit(s)'}</option>  
                    <option value={'bottle(s)'}>{'Bottles(s)'}</option>
                    <option value={'pack(s)'}>{'Pack(s)'}</option>
                    <option value={'carton(s)'}>{'Carton(s)'}</option>
                    <option value={'litre(s)'}>{'Litre(s)'}</option>        
                  </select>
                  <input type='default' onChange={(e) => setFormFields({...formFields, item_name: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="Item Name" />
                  <input type='number' onChange={(e) => setFormFields({...formFields, quantity: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="Starting quantity" />
                  
                  <div className="flex justify-between mt-5">
                        <button
                            onClick={handleSubmit}
                            className="
                            bg-[#037684] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Create Item
                        </button>
                    </div>
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

